<template>
  <div id="ais" class="pb-5">
    <section id="ais-search" aria-label="Rechercher un élément">

      <DirectoryFilters :disabled="loading" :isPartnerChecked="isPartnerChecked" @on-type-switch="onTypeSwitch"
        @on-directory-filter="onDirectoryFilter" />

      <div class="my-3" id="ais-needle">
        <input @keyup="onSearchInputKeyUp" class="form-control border" type="text" name="needle" id="needle"
          placeholder="Rechercher..." :disabled="loading" ref="searchInput">
      </div>
    </section>

    <section id="ais-listing" class="row">
      <div v-show="loading" class="w-100 text-center my-5">
        <span class="loader"></span>
        <p>Chargement en cours ...</p>
      </div>

      <div v-show="error" class="w-100 text-center my-5">
        <p class="alert alert-danger">Impossible de charger les données... <br>Si l'erreur persiste, vous pouvez nous
          contacter à l'adresse <a class="d-block display-6" href="mailto:contact@mobiloweb.fr">contact@mobiloweb.fr</a>
        </p>
      </div>

      <div ref="listing">
        <div class="my-3 col-12" v-for="(item, i) in listing" :key="i">
          <DirectorySingleItem :item="item" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import DirectorySingleItem from '@/components/DirectorySingleItem';
import DirectoryFilters from "@/components/DirectoryFilters";

import Search from '@/services/Search/SearchEngine';
import SearchContext from '@/services/Search/SearchContext';

const paginationListingLimit = 10;

const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});

export default {
  name: 'App',
  components: {
    DirectoryFilters,
    DirectorySingleItem
  },

  data() {
    return {
      rest_url: '',
      nonce: '',
      listing: [],
      loading: true,
      error: false,
      loadMore: false,
      isPartnerChecked: false
    }
  },

  async mounted() {
    this.rest_url = document.getElementById('rest_url').textContent;
    this.nonce = document.getElementById('nonce').textContent;

    const datas = await this.getListingItems().catch((e) => alert(e.message));

    if (!datas) {
      this.loading = false;
      this.error = true;
      return;
    }

    if (params.filter && !params.type) {
      document.querySelector("input[value='" + params.filter + "']").checked = true;
    }

    if (params.type) {
      if (params.type === 'true') {
        document.querySelector("input#journalist").checked = true;
        this.removeSearchParams('filter');
        this.isPartnerChecked = true;
      }
    }

    this.context = new SearchContext();
    this.context.setType(document.querySelector("input#journalist").checked);
    this.context.filter = document.querySelector("input[name='theme']:checked").value;

    if (params.search) {
      this.$refs.searchInput.value = params.search;
      this.context.search = params.search;
    }

    this.searchEngine = new Search(Object.values(datas), this.context);

    this.loading = false;

    this.listing = this.paginateData(this.searchEngine.search(this.context.search ?? ''), 0, paginationListingLimit);

    window.addEventListener('scroll', this.handleScroll)
  },

  unmounted() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    async getListingItems() {
      const response = await fetch(this.rest_url + 'ais/v1/query', { headers: { 'X-WP-Nonce': this.nonce } });

      if (response.ok) {
        return await response.json() || [];
      }

      throw new Error('HTTP-Error:' + response.status);
    },

    getNextListing(offset, limit) {
      const paginatedDatas = this.paginateData(this.searchEngine.currentDatas, offset, limit);
      this.listing.push(...paginatedDatas);
    },

    paginateData(datas, offset = 0, limit = paginationListingLimit) {
      return datas.slice(offset, offset + limit);
    },

    handleScroll() {
      if (this.$refs.listing.getBoundingClientRect().bottom < window.innerHeight) {
        if (!this.loadMore) {
          this.loadMore = true;
          this.getNextListing(this.listing.length, paginationListingLimit);
          this.loadMore = false;
        }
      }
    },

    onSearchInputKeyUp(event) {
      const pattern = event.target.value;

      if (pattern === '') {
        this.removeSearchParams('search');
        return this.listing = this.paginateData(this.searchEngine.search());
      }

      this.replaceSearchParams('search', pattern);
      this.listing = this.paginateData(this.searchEngine.search(pattern));
    },

    onTypeSwitch(e) {
      this.isPartnerChecked = e.currentTarget.checked
      this.context.setType(e.currentTarget.checked);

      if (this.isPartnerChecked) {
        this.replaceSearchParams('type', this.isPartnerChecked);
      } else {
        this.removeSearchParams('type');
      }

      this.listing = this.paginateData(this.searchEngine.search(this.context.search));
    },

    onDirectoryFilter(e) {
      this.context.filter = e.currentTarget.value;
      this.replaceSearchParams('filter', this.context.filter)
      this.listing = this.paginateData(this.searchEngine.search(this.context.search));
    },

    replaceSearchParams(key, value) {
      const url = new URL(window.location.href);
      const searchParams = url.searchParams;

      if (searchParams.has(key)) {
        searchParams.delete(key);
      }

      searchParams.set(key, value);

      history.pushState({}, null, url.toString());
    },

    removeSearchParams(key) {
      const url = new URL(window.location.href);
      const searchParams = url.searchParams;

      if (searchParams.has(key)) {
        searchParams.delete(key);
        history.pushState({}, null, url.toString());
      }
    }
  }
}
</script>

<style>
.elementor-element.elementor-element-7f95670.e-flex.e-con-boxed.e-con {
  padding: 0;
}

.loader {
  width: 48px;
  height: 48px;
  display: inline-block;
  position: relative;
}

.loader::after,
.loader::before {
  content: '';
  box-sizing: border-box;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 2px solid #F05A28;
  position: absolute;
  left: 0;
  top: 0;
  animation: animloader 2s linear infinite;
}

.loader::after {
  animation-delay: 1s;
}

:root {
  --popper-theme-background-color: black;
  --popper-theme-background-color-hover: black;
  --popper-theme-text-color: #ffffff;
  --popper-theme-border-width: 0px;
  --popper-theme-border-style: solid;
  --popper-theme-border-radius: 8px;
  --popper-theme-padding: 10px 20px;
  --popper-theme-box-shadow: 0 6px 30px -6px rgba(0, 0, 0, 0.25);
}

@keyframes animloader {
  0% {
    transform: scale(0);
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 0;
  }
}

.form-check-input:checked {
  background-color: #F05A28;
}

.form-check-input:focus,
.form-control:focus {
  box-shadow: 0 0 0 0.25rem #f05a2859;
}
</style>
